import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import {
  FullWidthTextField,
  SelectField
} from '../../../shared/Forms/FullWidthForm/fullWidthFormComponents';
import { fullSsn, required } from '../../../shared/Forms/validations';
import { connect } from 'react-redux';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import agreementStyles from '../ClientAgreement.module.css';
import styles from './AgreementPage8.module.css';
import stateMap from '../../PersonalDetailsForm/stateMap';
import { Grid } from '@material-ui/core';
import cftLogo from '../cft_logo.jpg';

const AgreementPage8 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="clientOnly" currentPage={8}>
    <div className={agreementStyles.contentHeader}>
      <img src={cftLogo} className={agreementStyles.cftLogo} alt="CFT Logo" />
      <br />
      <br />
      ACCOUNT AGREEMENT
      <br />
      <br />
    </div>
    <Field
      name="firstName"
      type="text"
      component={FullWidthTextField}
      label="Applicant First Name"
      validate={required}
    />
    <Field
      name="lastName"
      type="text"
      component={FullWidthTextField}
      label="Applicant Last Name"
      validate={required}
    />
    <Field
      name="ssn"
      type="text"
      component={FullWidthTextField}
      label="Applicant Social Security Number"
      validate={[required, fullSsn]}
    />
    <Field
      name="dateOfBirth"
      type="date"
      component={FullWidthTextField}
      label="Applicant Date of Birth"
      validate={required}
    />
    <Field
      name="streetAddress"
      type="text"
      component={FullWidthTextField}
      label="Street Address"
      validate={required}
    />
    <Field
      name="city"
      type="text"
      component={FullWidthTextField}
      label="City"
      validate={required}
    />
    <Field
      name="state"
      type="text"
      dataMap={stateMap}
      component={SelectField}
      label="State"
      validate={required}
    />
    <Field
      name="zip"
      type="number"
      component={FullWidthTextField}
      label="Zip Code"
      validate={required}
    />
    <Field
      name="phone"
      type="tel"
      component={FullWidthTextField}
      label="Phone Number"
      validate={required}
    />
    <Field
      name="email"
      type="text"
      component={FullWidthTextField}
      label="Email"
      validate={required}
    />
    <Field
      name="governmentId"
      type="text"
      component={FullWidthTextField}
      label="Government Issued Identification Number (i.e. Driver's License)"
      validate={required}
    />
    <Field
      name="contactFirstName"
      type="text"
      component={FullWidthTextField}
      label="Co-Applicant First Name (optional)"
    />
    <Field
      name="contactLastName"
      type="text"
      component={FullWidthTextField}
      label="Co-Applicant Last Name (optional)"
    />
    <Field
      name="contactSSN"
      type="text"
      component={FullWidthTextField}
      label="Co-Applicant SSN (optional)"
      validate={fullSsn}
    />
    <Field
      name="contactDateOfBirth"
      type="date"
      component={FullWidthTextField}
      label="Co-Applicant Date of Birth (optional)"
    />
    <br />
    <br />
    <Grid container className={agreementStyles.noScrollContainer}>
      <div>
        <b>Finxera</b> and the CFTPay Platform are the technology services (collectively, “Finxera
        Services”) used to administer a transactional deposit account (“Special Purpose Account,”
        hereinafter “SPA,” as further described below) for your debt settlement activity. The CFTPay
        Platform will be provided by Finxera, Inc. or a federally insured depository institution
        (collectively “Finxera”, “we,” “our, “ours,” “us”). FDIC coverage limited to $250,000 per
        social security number. See www.Finxera.com/licensing. The Welcome Packet that you receive,
        which is incorporated here by reference, will specify the bank at which your account will be
        held. The Finxera Services include customer support to help you and your Debt Settlement
        Provider manage your SPA. You understand that the Debt Settlement Provider identified above
        (“DSP”) does not own, control, or have any affiliation with Finxera. By signing below, you
        ask that Finxera and any successor provider provide you with the Finxera Services described
        below.
        <br />
        <br />
        <b>SPA.</b> You ask that an SPA be established for your benefit. The SPA will be used for
        the accumulation of funds to (i) repay your debts in accordance with the debt settlement
        plan (“Plan”) that you have made with your DSP, (ii) pay any fees due in connection with
        your Plan, in accordance with the separate contract executed between yourself and your DSP,
        when due, and (iii) pay any fees pursuant to your SPA, when due. You designate your DSP as
        your agent to transmit your funds transfer and disbursement instructions to Finxera in
        accordance with your Plan. We may act upon the instructions provided by your DSP, without
        inquiry, as though such instructions came directly from you.
      </div>
    </Grid>
    <br />
    <Grid container justify="space-between">
      <Grid
        item
        xs={12}
        lg={6}
        container
        justify="center"
        alignItems="stretch"
        className={[styles.pricingContainer, agreementStyles.noScrollContainer].join(' ')}>
        <Grid item xs={12} className={agreementStyles.contentHeader}>
          FEE SCHEDULE SPA FEES:
        </Grid>
        <Grid item xs={12}>
          <ul className={styles.leaders}>
            <li>
              <span>
                <b>Setup Fee (one-time fee)</b>
              </span>
              <span>$9.50</span>
            </li>
            <li>
              <span>
                <b>Service Fee (per month)</b>
              </span>
              <span>$12.50</span>
            </li>
            <span>
              <b>Transaction Fees:</b>
            </span>
            <br />
            <span>
              <b>Deposit Services (per deposit transaction):</b>
            </span>
            <li>
              <span>Non-Sufficient Funds</span>
              <span>$0.00</span>
            </li>
            <span>
              <b>Disbursement Services (per transaction):</b>
            </span>
            <li>
              <span>Creditor Payment</span>
              <span>$0.00</span>
            </li>
            <li>
              <span>Phone Payment</span>
              <span>$0.00</span>
            </li>
            <li>
              <span>Physical Check (STD)</span>
              <span>$0.00</span>
            </li>
            <li>
              <span>Physical Check (2 day)</span>
              <span>$10.00</span>
            </li>
            <li>
              <span>Physical Check (Overnight)</span>
              <span>$25.00</span>
            </li>
            <li>
              <span>Wire Transfer</span>
              <span>$25.00</span>
            </li>
          </ul>
        </Grid>
        <Grid item xs={12} className={agreementStyles.contentHeader}>
          FINXERA CUSTOMER SERVICE
        </Grid>
        <Grid item xs={12}>
          <div>
            <b>Website:</b> http://www.cftpay.com
          </div>
          <div>
            <b>Email:</b> support@cftpay.com
          </div>
          <div>
            <b>Telephone:</b> 1-888-348-4543 (toll free)
          </div>
          <div>
            <b>Address:</b> P.O. Box 940, San Jose, CA 95113
          </div>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={5} className={agreementStyles.noScrollContainer}>
        <b>Agreement.</b>
        <br />
        By signing this form, you (a) represent that the information set forth in this form is true
        and correct and (b) acknowledge reading, understanding, agreeing to, and receiving a
        completed copy of, this entire Account Agreement, including the Electronic Funds Transfer
        Authorization and the Additional Terms and Conditions, and, in particular, the Consent to
        Contact By Electronic and Other Means (¶5), Agreement to Arbitrate (¶23) and Consent to
        Electronic Disclosures (¶25).
      </Grid>
    </Grid>
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage8 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  existingSignature: formSelector(state, 'clientSignature')
}))(form) as any;
